<template>
    <el-dialog :visible.sync="dialogValue"
               :title="`${isNew? '添加': '更新'}联动分组`"
               custom-class="group-form-dialog set-group-dialog"
               class="global-dialog"
               width="640px"
               :close-on-click-modal="false">
         <template v-if="isNew">
             <label>设置联动组</label>
             <el-select v-model="ids" class="select-group" :multiple="false">
                 <el-option v-for="(item, index) in dataList" :key="index" :label="item.value" :value="item.id"></el-option>
             </el-select>
         </template>
        <template v-else>
            <label>设置联动组</label>
            <el-select v-model="ids" class="select-group" :multiple="true">
                <el-option v-for="(item, index) in dataList" :key="index" :label="item.value" :value="item.id"></el-option>
            </el-select>
        </template>
        <div slot="footer">
            <el-button @click="onCancel">暂不分组</el-button>
            <el-button type="primary" @click="onSave" :loading="confirmLoading">确认分组</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            value: {type: Boolean, default: false},
            groupIds: Array,
            confirmLoading: Boolean,
            projectId: String,
            isNew: Boolean,
            dataList: Array
        },
        data() {
            return {
                ids: null,
            }
        },
        computed: {
            dialogValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
        },
        watch: {
            value(v) {
                if (v) {
                    this.init();
                } else {
                    this.ids = null;
                }
            },
        },
        created() {
        },
        methods: {
            init() {
                this.ids = this.groupIds;
                this.originIds = [].concat(this.ids);
            },
            onCancel() {
                // if(this.originIds && this.originIds.length > 0 && this.ids.length === 0){
                //     this.$emit('onDelGroup')
                // }else{
                //     this.$emit('input', false);
                // }
                this.$emit('input', false);
            },
            onSave() {
                if(this.ids && this.ids.length > 0){
                    this.$emit('onConfirm', this.ids);
                }else{
                    this.$message.error('分组不能为空')
                }
            },
            addGroup() {
                this.$emit('add')
            },
        }
    }
</script>